import { fetchFeed, toRows, fundRow, pick, num, money, fmtDate, setText } from "./feeds.js";

// Daily ETF metrics: NAV, closing market price, premium/discount, 30-day median bid/ask, total assets.
export async function getDailyPerformance(fundID) {
    const rows = toRows(await fetchFeed("get_performance_daily", fundID));
    const fund = fundRow(rows);
    if (!fund) return;

    setText(".datadate", fmtDate(pick(fund, ["performDate", "asOfDate", "navDate", "date"])));

    const nav = num(pick(fund, ["naV_NoLoad", "nav", "navPerShare", "netAssetValue"]));
    if (nav != null) setText("#data_fundNav", "$" + nav.toFixed(2));

    const market = num(pick(fund, ["marketPrice", "closingPrice", "closingMarketPrice"]));
    if (market != null) setText("#data_marketPrice", "$" + market.toFixed(2));

    // Prefer an explicit percentage; otherwise derive it from the dollar difference or the two prices.
    let premPct = num(pick(fund, ["premiumDiscountPercent", "premiumDiscountPercentage", "premiumDiscountPct"]));
    if (premPct == null) {
        const premDollars = num(pick(fund, ["premiumDiscount"]));
        if (premDollars != null && nav) premPct = (premDollars / nav) * 100;
        else if (market != null && nav) premPct = ((market - nav) / nav) * 100;
    }
    if (premPct != null) setText("#data_premiumDiscountPercentage", signed(premPct) + "%");

    const spread = num(pick(fund, ["rollingMidPrice", "medianBidAskSpread", "bidAskSpread", "thirtyDayMedianBidAsk"]));
    if (spread != null && spread !== 0) setText("#data_medianBidAsk", (Math.abs(spread) <= 1 ? spread * 100 : spread).toFixed(2) + "%");

    setText("#data_totalAssets", money(pick(fund, ["totalNetAssets", "netAssets", "totalAssets", "aum"])));
}

function signed(n) {
    const s = n.toFixed(2);
    return n > 0 ? "+" + s : s;
}
